import instances from './map';
import generateToken from './generateToken';

const getRequestPassword = async codigo =>
  instances
    .wslogin({
      method: 'GET',
      url: `/recuperacao`,
      headers: {
        usuario: codigo
      }
    })
    .then(response => response.data)
    .catch(err => Promise.reject(new Error(err.response.data.descricao)));

export const sendRecoverTokenEmail = async codigo => {
  await generateToken('wslogin');
  let response;

  try {
    response = await instances.wslogin({
      method: 'GET',
      url: `/usuario/${codigo}`
    });
  } catch (error) {
    return Promise.reject('Prestador não encontrado');
  }

  try {
    const retorno = await generateRecoverToken(codigo, response.data.email);

    if (!retorno.data.success) {
      return Promise.reject(retorno.data.message);
    }
  } catch (error) {
    return Promise.reject(new Error(error));
  }

  const hideEmail = response.data.email.replace(/(.{3})(.*)(?=@)/, function (gp1, gp2, gp3) {
    for (let i = 0; i < gp3.length; i++) {
      gp2 += '*';
    }
    return gp2;
  });

  return hideEmail;
};

const generateRecoverToken = async (codBenef, email) => {
  await generateToken('prestador_odonto');

  return instances.prestadores({
    method: 'POST',
    url: `/beneficiarios/${codBenef}/recover-token`,
    data: {
      email: email
    },
  })
    .then(response => { return response.data })
    .catch(err => Promise.reject(new Error(err)));
}

export const validateToken = async data => {
  await generateToken('prestador_odonto');

  return instances
    .prestadores({
      method: 'GET',
      url: `/beneficiarios/${data.codBenef}/recover-token/${data.recoverToken}`
    })
    .then(response => {
      return response.data;
    })
    .catch(err => Promise.reject(new Error(err)));
};

export const wsloginRecover = async codigo => {
  try {
    let usuario = { codigo: '' };
    await generateToken('wslogin');
    usuario = await getRequestPassword(codigo);
    return usuario;
  } catch (err) {
    return Promise.reject(new Error(err.message));
  }
};

const getUserInfo = async codigo => {
  return instances
    .wslogin({
      method: 'GET',
      url: `/usuario/${codigo}`
    })
    .then(response => {
      return response.data;
    })
    .catch(err => Promise.reject(new Error(err)));
};

export const newLogin = async data => {
  await generateToken('wslogin');

  const userInfo = await getUserInfo(data.codigo);

  return instances
    .wslogin({
      method: 'POST',
      url: `/login`,
      data: {
        pInfoNewLogin: {
          idServico: 3,
          usuario: userInfo.codigo,
          senha: data.newPassword,
          nome: userInfo.nomeUsuario,
          email: userInfo.email,
          dddCelular: data.ddd,
          celular: data.celular,
          dadoValidacao1: `\/Date(${new Date().getTime()})\/`,
          dadoValidacao2: 0,
          codigo: 3
        }
      }
    })
    .then(response => response.data)
    .catch(err => {
      throw err.response;
    });
};

export default { newLogin, wsloginRecover, sendRecoverTokenEmail, validateToken };
